import React from "react";
import { Alert, AlertTitle, Box, Button, Stack } from "@mui/material";

export default class ErrorBoundary extends React.Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught", error, info);
  }

  handleReset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <Box sx={{ p: 4, maxWidth: 720, mx: "auto" }}>
          <Alert severity="error">
            <AlertTitle>Something went wrong</AlertTitle>
            <Box component="pre" sx={{ fontSize: 12, whiteSpace: "pre-wrap" }}>{this.state.error?.message}</Box>
          </Alert>
          <Stack direction="row" spacing={1} mt={2}>
            <Button variant="contained" onClick={this.handleReset}>Try again</Button>
            <Button onClick={() => (window.location.href = "/")}>Go home</Button>
          </Stack>
        </Box>
      );
    }
    return this.props.children;
  }
}
